// JsFromRoutes CacheKey e3f7418155bbdbd122012204ece113ce
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  suggestGiftTips: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/places/:id/suggest_gift_tips'),
  updateImage: /* #__PURE__ */ definePathHelper('put', '/admin/consumer/places/:id/update_image'),
  urlSlugTypeahead: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/places/url_slug_typeahead'),
  urlSlugExactTypeahead: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/places/url_slug_exact_typeahead'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/places/:id'),
}
